import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showMessage, showError, confirmAction } from '../../actions/uiActions';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import PaginatedTable from '../../components/PaginatedTable';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import Add from '@mui/icons-material/Add';
import FormsApi from '../../api/forms';
import { loadForms, addForm, updateForm } from '../../actions/dataActions';
import Form from '../../forms/Form';

class Forms extends Component {
    state = {
        forms: [],
        loading: true,
        domain: null,
        count: 0,
        page: 0,
        mode: "default",
        deleting: false,
        strings: false,
        survey: false,
        downloading: false
    }
    componentDidMount() {
        this.load();
    }

    load = async () => {
        try {
            let forms = await FormsApi.list()
            if (forms)
                this.setState({ loading: false, forms }, this.props.loadForms(forms))
            else
                this.setState({ loading: false }, this.props.showError)
        } catch (error) {
            this.setState({ loading: false }, this.props.showError)
        }
    }
    
    delete = async (id) => {
        this.props.confirmAction("You are going to delete this domain permanentely. Do you want to proceed?", () => this.setState({ deleting: true, form: { _id: id } }, async() => {
            
            try {
                const response = await FormsApi.delete(id)
                if (response) {
                    this.setState({ deleting: null }, () => {
                        this.props.showMessage('The form has been deleted.');
                        this.load();
                    });
                } else {
                    this.setState({ form: null, deleting: false }, this.props.showError)
                }
            } catch (error) {
                this.setState({ form: null, deleting: false }, this.props.showError)
            }
        }))
    }

    render() {
        return <section className="animated fadeIn">
            <header>
                <h1>Forms Management{this.state.mode == "add" ? ` > Add New Form` : (this.state.mode == 'edit' ? ` > Edit Form > ${this.state.form.name}` : '')}</h1>
                {this.state.mode == "default" && <Tooltip title="Add new Form" placement="top" className="floating-button">
                    <Fab onClick={() => this.setState({ mode: 'add' })} variant="round" color="primary" aria-label="Add" >
                        <Add />
                    </Fab>
                </Tooltip>}
            </header>
            <div className="line-break"></div>

            {(this.state.mode == "add" || this.state.mode == "edit") &&
                <Form
                    type={"esign"}
                    fromPage={"Nav"}
                    mode={this.state.mode}
                    onCreated={form => {
                        this.props.addForm(form);
                        this.load()
                        this.setState({
                            form: form.id,
                            mode: 'default',
                            editForm: null
                        });
                    }}
                    onUpdated={form => {
                        this.props.updateForm(form);
                        this.load()
                        this.setState({
                            form: form.id,
                            mode: 'default',
                            editForm: form
                        });
                    }}
                    onCancel={() => this.setState({ mode: 'default', editForm: null, form: '' })}
                    form={this.state.mode == "add" ? '' : this.state.form.id}
                />
                }
            
            {this.state.mode == "default" && <div className="row">
                <div className="col-12">
                    <Paper>
                        <PaginatedTable loading={this.state.loading} rows={this.state.forms.map(form => {
                            return {
                                properties: {
                                    key: form._id
                                },
                                columns:
                                    [
                                        {
                                            properties: {
                                                key: `${form._id}-1`
                                            },
                                            value: form.name
                                        },
                                        {
                                            properties: {
                                                key: `${form._id}-2`
                                            },
                                            value: form.description
                                        },
                                        {
                                            properties: {
                                                key: `${form._id}-4`
                                            },
                                            value: <div className="text-center">
                                                <Tooltip title="Edit Form">
                                                    <IconButton onClick={() => this.setState({ mode: "edit", form })}>
                                                        <Edit />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete Form">
                                                    <IconButton disabled={this.state.deleting && this.state.form && this.state.form._id == form._id} onClick={() => this.delete(form._id)}>
                                                        {(!this.state.deleting || !this.state.form || !this.state.form._id != form._id) && <Delete />}
                                                        {this.state.form && this.state.form._id == form._id && <CircularProgress size={24} />}
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        }
                                    ]
                            };
                        })}
                            emptyMessage="No forms have been added"
                            columns={[
                                {
                                    name: "Form Name",
                                    properties:
                                    {
                                        key: 1,
                                        className: "width40pct"
                                    }
                                },
                                {
                                    name: "Form Description",
                                    properties:
                                    {
                                        key: 3,
                                        className: "width40pct"
                                    }
                                },
                                {
                                    name: "Options",
                                    properties:
                                    {
                                        key: 5,
                                        className: "width20pct"
                                    }
                                }
                            ]} />
                    </Paper>
                </div>
            </div>}

        </section>
    }
}
const mapStateToProps = state => {
    return {
        customForms: state.data.forms
    };
};
export default connect(mapStateToProps, {
    showError, loadForms, addForm,
    updateForm, showMessage, confirmAction })(Forms);